import { Pipe, PipeTransform } from '@angular/core';
import { EntityType } from '../model/search-constants';

@Pipe({
  name: 'entityType',
  standalone: true
})
export class EntityTypePipe implements PipeTransform {
  transform(id: string): string {
    return entityTypeLabels[ id ] ?? id;
  }
}

export const entityTypeLabels = {
  [ EntityType.BOOK ]: 'Book',
  [ EntityType.ARTICLE ]: 'Article',
  [ EntityType.EVENT ]: 'Event',
  [ EntityType.THREAD ]: 'Thread',
  [ EntityType.SECTION ]: 'Section',
  [ EntityType.BOOK_CHAPTER ]: 'Chapter',
  [ EntityType.SOFTWARE_ARTIFACT ]: 'Software Artifact',
  [ EntityType.PATH ]: 'On-Demand Course',
  [ EntityType.PATH_CHAPTER ]: 'Chapter',
  [ EntityType.EXERCISE ]: 'Exercise',
  [ EntityType.GUIDE ]: 'Workbook',
  [ EntityType.LESSON ]: 'Lesson',
  [ EntityType.FEED ]: 'Feed'
};
